/* src/app/shared/components/modal-box/box-modal.component.scss */
:host {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: row;
}
.main-container {
  margin: auto;
  display: flex;
  flex-direction: column;
  width: 850px;
  background: #ffffff;
  justify-content: center;
}
.main-container > div {
  max-height: 580px;
  overflow-x: hidden;
  overflow-y: scroll;
}
/*# sourceMappingURL=box-modal.component.css.map */
